import React from "react"
import { useReactiveVar } from "@apollo/client"
import isNil from "lodash/isNil"
import { showAccountProfileModalVar } from "cache"

import AccountProfileModal from "components/AccountProfileModal"
import { useAccountProfileModal } from "./hooks/useAccountProfileModal"

const GlobalAccountProfileModal = () => {
  const isOpen = !isNil(useReactiveVar(showAccountProfileModalVar)) || false
  const { closeModal, handleProfileComplete } = useAccountProfileModal()

  return (
    <AccountProfileModal
      isOpen={isOpen}
      onClose={closeModal}
      onComplete={handleProfileComplete}
    />
  )
}

export default GlobalAccountProfileModal
